// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__z6YWt","container":"styles_container__xPoz-","title":"styles_title__2Hg6S","wrapper":"styles_wrapper__lidUl","answer":"styles_answer__3H2Gy"};